import styled from "styled-components";
const ModalHeader = styled("div")(({ theme }) => ({
  borderBottom: `1px solid ${theme.borderColor}`,
  color: theme.color.gray9,
  fontSize: theme.fontSize.lg,
  fontWeight: theme.fontWeight.medium,
  lineHeight: theme.lineHeight.lg,
  padding: "12px 16px"
}));
export {
  ModalHeader
};
